import React, { useState, useEffect } from "react";
import Table from "../../../../common/table/Table.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular, solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import CreateSudovi from "../../../components/sudovi-component/CreateSudovi.component";
import SideModal from "../../../../common/modal/SideModal.component";
import CourtClient from "../../../api-services/coders/courts/courts-client";
import HandlingResponse from "../../../../common/handling-response/handlingResponse";
import ButtonWithComfirmation from "../../../../common/button-with-confirmation/ButtonWithConfirmation.component";

const Sudovi = () => {
  const tableName = "SP_SUDOVI";
  
  const columns = [
    {
      Header: "Назив",
      accessor: "name",
      disableFilters: false,
    },
    {
      Header: "Врста суда",
      accessor: "courtKind.name",
      disableFilters: false,
    },
    {
      Header: "Тежина",
      accessor: "weight",
    },
    {
      Header: "Актуелни",
      accessor: "isActual",
      Cell: ({ row }) => {
        return row.original.isActual && <FontAwesomeIcon icon={solid("check")} />;
      },
    },
    {
      Header: "Активан",
      accessor: "isActive",
      Cell: ({ row }) => {
          return row.original.isActive && <FontAwesomeIcon icon={solid("check")} />;
      },
    },
    {
      accessor: "edit",
      disableSortBy: true,
      className: "two-buttons-column",
      Cell: ({ row }) => {
        return (
          <>
            <button
              className="btn btn-primary table-btn"
              onClick={() => onEditClick(row.original.id)}
              type="button"
            >
              <FontAwesomeIcon icon={solid("pencil")} />
            </button>
            <ButtonWithComfirmation
              className="btn btn-danger table-btn" 
              onClick={() => onDeleteClick(row.original.id)}
              contentText={"Суд ће бити трајно обрисан."}
              handleYesText={"Обриши"}
              >
              <FontAwesomeIcon icon={solid("times")} />
            </ButtonWithComfirmation>
          </>
        );
      },
    },
  ];

  const [court, setCourt] = useState([]);
  const [isCreate, setIsCreate] = useState(true);
  const [show, setShow] = useState(false);
  const [rowData, setRowData] = useState({
    id: 0,
    name: "",
    weight: "",
    isActual: true,
    isActive: true,
    userGuid: "",
    lastModifyDate: "",
  });
  const client = new CourtClient();
  
  useEffect(() => {
    Court();
  }, []);

  const showModal = () => setShow(true);
  const hideModal = () => {
    setShow(false);
    setRowData({
      id: 0,
      name: "",
      weight: "",
      isActual: true,
      isActive: true,
      userGuid: "",
      lastModifyDate: "",
    });
  }

  const onCreateClick = () => {
    setIsCreate(true);
    setRowData({
      id: 0,
      name: "",
      weight: "",
      isActual: true,
      isActive: true,
      userGuid: "",
      lastModifyDate: "",
    });
    showModal();
  };

  const onEditClick = async (id) => {
    var response = await client.GetCourtForUpdate(id)  
    setIsCreate(false);
    setRowData(response.data);
    showModal();
  };
  
  const onDeleteClick = async (id) => {
    var response = await client.DeleteCourt(id);
    var handledResponse = HandlingResponse(response);
    if(handledResponse !== 'Error') {
      let courtCopy = court.filter((x) => x.id !== id);
      setCourt(courtCopy);
    }
  };

  const Court = async () => {
    await client.Court().then((response) => {
      var handledResponse = HandlingResponse(response);
      handledResponse !== 'Error' && setCourt(handledResponse);
    });
  }
  
  return (
    <>
      <h4>Судови</h4>
      <div className="text-right">
        <button
          onClick={onCreateClick}
          type="button"
          className="btn btn-primary"
        >
          Додај нови суд
        </button>
      </div>
      <Table
        columns={columns}
        data={court}
        tableName={tableName}
        rememberFilter={true}
        serverSide={false}
      />
      <SideModal
        show={show}
        handleClose={hideModal}
        title={isCreate ? "Креирање новог суда" : "Измена суда"}
      >
        <CreateSudovi
          row={rowData}
          isCreate={isCreate}
          handleCallback={() => {
            hideModal();
            Court();
          }}
        />
      </SideModal>
    </>
  );
};

export default Sudovi;
